import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControl, InputLabel, Select, MenuItem, TextField
} from '@mui/material';

export default function PageNumberModal({ open, onClose, initial, onSave, onDisable }) {
  const [position, setPosition] = useState(initial?.position ?? 'bottom-right');
  const [format, setFormat] = useState(initial?.format ?? 'arabic');
  const [fontFamily, setFontFamily] = useState(initial?.fontFamily ?? 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif');
  const [fontSize, setFontSize] = useState(initial?.fontSize ?? 12);

  useEffect(() => {
    setPosition(initial?.position ?? 'bottom-right');
    setFormat(initial?.format ?? 'arabic');
    setFontFamily(initial?.fontFamily ?? 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif');
    setFontSize(initial?.fontSize ?? 12);
  }, [initial, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      disableRestoreFocus
    >
      <DialogTitle>Page Number</DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="dense">
          <InputLabel id="pn-position">Position</InputLabel>
          <Select
            labelId="pn-position"
            label="Position"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          >
            <MenuItem value="top-left">Top Left</MenuItem>
            <MenuItem value="top-middle">Top Middle</MenuItem>
            <MenuItem value="top-right">Top Right</MenuItem>
            <MenuItem value="bottom-left">Bottom Left</MenuItem>
            <MenuItem value="bottom-middle">Bottom Middle</MenuItem>
            <MenuItem value="bottom-right">Bottom Right</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel id="pn-format">Number Format</InputLabel>
          <Select
            labelId="pn-format"
            label="Number Format"
            value={format}
            onChange={(e) => setFormat(e.target.value)}
          >
            <MenuItem value="arabic">1, 2, 3…</MenuItem>
            <MenuItem value="roman-upper">I, II, III…</MenuItem>
            <MenuItem value="roman-lower">i, ii, iii…</MenuItem>
          </Select>
        </FormControl>

        {/* Font Family: dropdown with common families + Custom */}
        <FormControl fullWidth margin="dense">
          <InputLabel id="pn-font-family">Font Family</InputLabel>
          <Select
            labelId="pn-font-family"
            label="Font Family"
            value={fontFamily}
            onChange={(e) => setFontFamily(e.target.value)}
          >
            <MenuItem value="Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif">Inter / System</MenuItem>
            <MenuItem value="Georgia, Cambria, Times New Roman, Times, serif">Serif (Georgia)</MenuItem>
            <MenuItem value="Times New Roman, Times, serif">Times New Roman</MenuItem>
            <MenuItem value="Garamond, Baskerville, Times New Roman, serif">Garamond</MenuItem>
            <MenuItem value="Palatino Linotype, Book Antiqua, Palatino, serif">Palatino</MenuItem>
            <MenuItem value="Arial, Helvetica, sans-serif">Arial</MenuItem>
            <MenuItem value="Helvetica, Arial, sans-serif">Helvetica</MenuItem>
            <MenuItem value="Tahoma, Verdana, Segoe, sans-serif">Tahoma</MenuItem>
            <MenuItem value="Trebuchet MS, Tahoma, sans-serif">Trebuchet</MenuItem>
            <MenuItem value="Verdana, Tahoma, Geneva, sans-serif">Verdana</MenuItem>
            <MenuItem value="Courier New, Courier, monospace">Courier New</MenuItem>
            <MenuItem value="Monaco, Consolas, Lucida Console, monospace">Monaco/Consolas</MenuItem>
            <MenuItem value="custom">Custom…</MenuItem>
          </Select>
        </FormControl>

        {/* Show a custom text box only when "Custom…" is selected */}
        {fontFamily === 'custom' && (
          <TextField
            margin="dense"
            fullWidth
            label="Custom CSS font-family"
            placeholder={`e.g. "EB Garamond", Georgia, serif`}
            onChange={(e) => setFontFamily(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onDisable} color="error">Disable</Button>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => onSave({ position, format, fontFamily, fontSize })}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
